// extracted by mini-css-extract-plugin
module.exports = {"calendarWrapper":"Calendar_calendarWrapper__38Z9r","blockWrapper":"Calendar_blockWrapper__U5vZa","block":"Calendar_block__3s_LA","blockFilled":"Calendar_blockFilled__c9WmF"};